import React, { useContext, useEffect, useRef } from 'react';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import Header from '../../Shared/Headers/Header';
import TopCardsExpert from './TopCardsExpert';
import Activity from '../../Splitter/Dashboard/Activity/Activity';
import Calendar from '../../Splitter/Dashboard/Calendar';
// import DueDate from '../Dashboard/DueDate';
import useCheckout from '../../Contexts/useCheckout';
import { ExpertContext } from '../../Contexts/contexts';
import useAuth from '../../Contexts/useAuth';
import usePaymentPeriod from '../../Contexts/usePaymentPeriod';

function DahsboardExpert() {
	const expertContext = useContext(ExpertContext);
	const { checkAuth } = useAuth();
	const ref = useRef(true);

	const checkout = useCheckout();
	const checkPaymentPeriod = usePaymentPeriod();

	useEffect(() => {
		if (checkAuth()) {
			if (checkout('/dashboard')) {
				if (checkPaymentPeriod('/dashboard')) {
					const firstRendering = ref.current;

					if (firstRendering) {
						ref.current = false;
						expertContext?.refreshClientExpertRelations();
						expertContext?.refreshAppointments();
					}
				}
			}
		}
	}, [expertContext, checkAuth, checkout, checkPaymentPeriod]);

	return (
		<>
			<div className="container-header">
				<div>
					<Header />
				</div>
			</div>
			<TopCardsExpert />
			<div className="container-dashboard">
				<SideMenu />
				<div className="container-duedate-activity">
					{/* <div className="container-due-date">
						<DueDate />
					</div> */}
					<div className="container-activity">
						<Activity />
					</div>
				</div>
				<div className="container-calendar-expert">
					<div className="container-calendar">
						<Calendar />
					</div>
				</div>
			</div>
		</>
	);
}

export default DahsboardExpert;
